/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import commonSizes from "./common-sizes";

const space = {
  ...commonSizes,
};

export default space;
